<template>
  <WdsSelect
    v-model="vmodel"
    multi-select
    class="tw-w-full"
    :list="list"
    :placeholder="$t('Select options to filter by')"
  />
</template>

<script lang="ts" setup>
import { WdsSelect } from '@worksome/wds-components'
import { computed } from 'vue'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'

const props = defineProps<{ list: { value: string; label: string }[] }>()

const model = defineModel<string[] | null>()

const vmodel = computed({
  get() {
    if (!model.value || model.value.length === 0) return []
    return model.value
      .map((id) => props.list.find(({ value }) => value === id))
      .filter(Boolean)
  },
  set(selected: { value: string; label: string }[]) {
    model.value = selected.map(({ value }) => value)
  },
})
</script>
